import request from 'api/request';
import {handleError} from 'helpers';

import {unitsActionTypes as actions} from './actionTypes';

export const getUnits = () => dispatch => {
  return request({url: '/units'})
    .then(data => {
      const results =
        data && data.data && data.data.results ? data.data.results : [];
      dispatch({
        type: actions.LOAD_UNITS_SUCCESS,
        units: results,
      });
    })
    .catch(error => {
      handleError('Unable to load units', error, dispatch);
    });
};

export const saveNewUnit = unitName => dispatch => {
  return request({
    url: '/units',
    method: 'POST',
    body: {Name: unitName},
  })
    .then(response => {
      if (response.status === 422) {
        throw new Error(response.data);
      } else if (response.status === 500) {
        throw new Error('An unknown server has occurred');
      }
      dispatch({type: actions.NEW_UNIT_ADDED, unit: response.data});
      return response.data;
    })
    .catch(error => {
      handleError('Unable to save item', error, dispatch);
    });
};



// WEBPACK FOOTER //
// ./src/actions/unitsActions.js